var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm4.193 5.229l-5.771 5.885-2.615-2.666a.755.755 0 0 0-1.083 0c-.299.305-.299.8 0 1.104l3.156 3.22c.3.304.784.304 1.083 0l6.313-6.439c.299-.305.299-.8 0-1.104a.755.755 0 0 0-1.083 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.29d7d80a02d3f863a64fa67343aac02b.svg";
export { ForwardRef as ReactComponent };